import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { MembershipService } from 'src/app/simulator-booking/services/membership.service';

@Component({
  selector: 'membership-plan-create-modal',
  templateUrl: './membership-plan-create-modal.component.html',
  styleUrl: './membership-plan-create-modal.component.scss',
  standalone: false,
})
export class MembershipPlanCreateModalComponent extends BaseModalComponent implements OnInit {
  membershipPlanForm: FormGroup;
  billingIntervals = ['day', 'week', 'month', 'year'];
  organizationId: string | null = null;

  constructor(private fb: FormBuilder, 
    private sessionService: SessionService, 
    private membershipService: MembershipService,
    public dialogRef: MatDialogRef<MembershipPlanCreateModalComponent>) {
    super();
  }

  ngOnInit(): void {
    this.organizationId = this.sessionService.getUser()?.organizationId || null;
    this.membershipPlanForm = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      price: [0, [Validators.required, Validators.min(0)]],
      billingInterval: ['month', Validators.required],
      billingIntervalCount: [1, [Validators.required, Validators.min(1)]],
      maxBookingsPerMonth: [0, [Validators.required, Validators.min(0)]],
      discountPercent: [0, [Validators.min(0), Validators.max(100)]],
      isActive: [true]
    });
  }

  onSubmit() {
    if (this.membershipPlanForm.valid && this.organizationId) {
      this.isLoading = true;
      const formValue = {
        organizationId: this.organizationId,
        createdBy: this.sessionService.getUserId(),
        ...this.membershipPlanForm.value
      };
      this.membershipService.createPlan(formValue).subscribe((response) => {
        this.dialogRef.close("save");
        this.isLoading = false;
      }, err =>{
        this.isLoading = false;
        this.setError(err, this.membershipPlanForm);
      });
    }
  }
}
